import React from 'react';
import { useTranslation } from 'react-i18next';
import { SectionHeader } from './CabinetHeader';
import './SettingsContent.css';

const SettingsContent = () => {
  const { t } = useTranslation();

  return (
    <div className="settings-content-v3">
      <SectionHeader title={t('cabinet.settings.title')} />
      <div className="settings-section-content">
        <div className="settings-group">
          <h3 className="settings-group-title">{t('cabinet.settings.preferences.title')}</h3>
          <div className="settings-item">
            <label>{t('cabinet.settings.preferences.language')}</label>
            <select className="settings-input">
              <option>English</option>
              <option>Русский</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsContent;

